import { IonSkeletonText } from '@ionic/react';

import styles from '@components/explore/Explore.module.css';
import loaderStyles from '@components/loaders/LoaderStyles.module.css';

const ExploreMarketplaceLoader = () => (
  <div className={styles.marketplaceItems}>
    {Array.from(Array(10)).map(() => (
      <IonSkeletonText animated className={loaderStyles.marketplaceCard} key={Math.random()} />
    ))}
  </div>
);

export default ExploreMarketplaceLoader;
